import { useEffect, useRef, useState } from 'react';

/**
 * @deprecated Use UIC's `useDebounce` instead.
 */
export default function useDebounce(unbouncedValue, delay, onDebouncedCallback) {
  const timeoutRef = useRef();
  const [debouncedValue, setDebouncedValue] = useState(unbouncedValue);

  useEffect(() => {
    timeoutRef.current && clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setDebouncedValue(unbouncedValue), delay);

    // Clean up debounced state-setter
    return () => timeoutRef.current && clearTimeout(timeoutRef.current);
  }, [unbouncedValue, delay]);

  useEffect(() => {
    onDebouncedCallback && onDebouncedCallback(debouncedValue);
  }, [debouncedValue]);

  return debouncedValue;
}
